<template>
  <form-box
    title="用户信息"
    :button-text="type === 'check' ? '' : '增加用户'"
    @add="addUserInfo"
  >
    <template v-if="userInfoFormArr && userInfoFormArr.length">
      <div
        v-for="(item, index) in userInfoFormArr"
        :key="index"
        class="form-content"
      >
        <el-form
          :ref="`userInfoForm${index}`"
          class="form-box"
          size="medium"
          label-position="top"
          :rules="rules"
          :model="item"
        >
          <div class="delete-btn" v-if="type !== 'check'">
            <span @click="deleteUserInfo(index)"
              ><i class="el-icon-delete"></i>删除</span
            >
          </div>
          <div class="form-row">
            <!-- 左侧表单 -->
            <div class="form-column">
              <el-form-item label="用户类型">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.type"
                  placeholder="请选择用户类型"
                >
                  <el-option
                    v-for="item in allSelectData.userTypeArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件类型">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.documentType"
                  placeholder="请选择证件类型"
                >
                  <el-option
                    v-for="item in allSelectData.documentTypeArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="文化程度" prop="educationLevel">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.educationLevel"
                  placeholder="请选择文化程度"
                >
                  <el-option
                    v-for="item in allSelectData.educationLevelArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工作年限" prop="workYears">
                <el-input
                  v-model="item.workYears"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="2"
                  placeholder="请输入工作年限"
                >
                  <template slot="append">年</template>
                </el-input>
              </el-form-item>
            </div>
            <!-- 右侧表单 -->
            <div class="form-column">
              <el-form-item label="用户姓名">
                <el-input
                  v-model="item.name"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="20"
                  placeholder="请输入用户姓名"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="证件号码">
                <el-input
                  v-model="item.documentCode"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="30"
                  placeholder="请输入证件号码"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="专业职称">
                <el-input
                  v-model="item.jobType"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="30"
                  placeholder="请输入专业职称"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <Empty v-else emptyTxt="暂无用户信息"></Empty>
  </form-box>
</template>

<script>
import FormBox from "./FormBox.vue";
import Empty from "./Empty.vue";

export default {
  name: "UserInfo",
  components: {
    FormBox,
    Empty,
  },
  props: {
    userInfoFormArr: {
      type: Array,
      default() {
        return [];
      },
    },
    allSelectData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateInteger = (rule, value, callback) => {
      if (value && !/^[1-9]\d*$/.test(value)) {
        return callback(new Error("请输入正整数"));
      }
      return callback();
    };
    return {
      rules: {
        workYears: [
          {
            trigger: "blur",
            validator: validateInteger,
          },
        ],
      },
    };
  },
  methods: {
    addUserInfo() {
      this.$emit("add", "userInfoDTOList");
    },
    deleteUserInfo(index) {
      this.$emit("delete", "userInfoDTOList", index);
    },
  },
};
</script>

<style scoped lang="scss">
.form-content {
  background: #f7f9fb;
  margin-bottom: 20px;
  .form-box {
    .delete-btn {
      text-align: right;
      font-size: 14px;
      color: #ff5c5c;
      padding: 18px 16px 0 0;
      span {
        cursor: pointer;
      }
      i {
        font-size: 18px;
        margin-right: 4px;
      }
    }
    .form-row {
      display: flex;

      .form-column {
        padding: 40px 0 30px 100px;
        flex: 1;
        ::v-deep .el-form-item__label {
          line-height: normal !important;
        }
        .ipt,
        .el-select {
          width: 374px;
        }
      }
    }
  }
}
</style>
